// components/FlashBarAdmin.jsx
import React, { useState } from 'react';
import FlashBar from '../components/FlashBar';
import axios from "axios";
import config from '../config/config';
const FlashBarAdmin = () => {
  const [enabled, setEnabled] = useState(true);
  const [preset, setPreset] = useState('clean-light');
  const [prefix, setPrefix] = useState('New Collection');
  const [text, setText] = useState('25% off sitewide — Limited time');
  const [ctaText, setCtaText] = useState('Shop Now');
  const [link, setLink] = useState('/sale');
  const [countdownDate, setCountdownDate] = useState('');
  const [dismissible, setDismissible] = useState(true);
   const [countdownHours, setCountdownHours] = useState(12);
  const [countdownMinutes, setCountdownMinutes] = useState(34);
  const [devMode, setDevMode] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState('');
  const [textColor, setTextColor] = useState('');
  const [prefixTextColor, setPrefixTextColor] = useState('');
  const [prefixIcon, setPrefixIcon] = useState('');
  const [prefixIconColor, setPrefixIconColor] = useState('');
  const [height, setHeight] = useState('');
  const [ctaColor, setCtaColor] = useState('');

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(23, 59, 0, 0);

  const previewConfig = {
    enabled,
    preset,
    dismissible,
    devMode,
    messages: [{
      prefix,
      text,
      ctaText: preset === 'clean-light' ? ctaText : undefined,
      link: preset === 'clean-light' ? link : undefined,
      countdownEnd: preset === 'premium-dark' ? countdownDate || tomorrow.toISOString() : null,
    }],
    customStyles: devMode ? { backgroundColor, textColor,ctaColor, height, prefixTextColor,prefixIcon,prefixIconColor } : {},
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white border-b px-6 py-4 shadow-sm">
        <h1 className="text-2xl font-semibold">Flash Bar Editor</h1>
      </div>

      <div className="max-w-9xl mx-auto p-6 grid grid-cols-1 lg:grid-cols-2 gap-8">
        {/* Settings */}
        <div className="space-y-6">
         {/* Enable Toggle */}
          <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-semibold text-gray-900">Enable Flash Bar</h3>
                <p className="text-sm text-gray-500">Display the bar at the top of your store</p>
              </div>
              <button
                onClick={() => setEnabled(!enabled)}
                className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                  enabled ? 'bg-blue-600' : 'bg-gray-200'
                }`}
              >
                <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${enabled ? 'translate-x-6' : 'translate-x-1'}`} />
              </button>
            </div>
          </div>


          {enabled && (
            <>
              {/* Preset Selector */}
              <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6">
                <label className="block text-lg font-semibold text-gray-900 mb-4">Choose Design Template</label>
                <div className="grid grid-cols-2 gap-4">
                  {[
                    { value: 'clean-light', label: 'Clean Light', desc: 'Minimal with dividers & CTA' },
                    { value: 'premium-dark', label: 'Premium Dark', desc: 'Urgent with countdown & gradient' },
                  ].map((p) => (
                    <button
                      key={p.value}
                      onClick={() => {
                        setPreset(p.value);
                        setHeight(p.value === 'clean-light' ? '56px' : '48px');
                        setBackgroundColor(p.value === 'clean-light' ? '#ffffff' : 'linear-gradient(to right, #111827, #1F2937, #111827)');
                        setTextColor(p.value === 'clean-light' ? '#1f2937' : '#ffffff');
                      }}
                      className={`p-4 rounded-lg border-2 text-left transition-all ${
                        preset === p.value
                          ? 'border-blue-500 bg-blue-50 text-blue-900 shadow-md'
                          : 'border-gray-200 hover:border-gray-300 hover:shadow-sm'
                      }`}
                    >
                      <span className="block font-medium text-sm">{p.label}</span>
                      <span className="text-xs text-gray-500">{p.desc}</span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Content Editor */}
              <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 space-y-4">
                <h3 className="text-lg font-semibold text-gray-900">Edit Content</h3>
                
                {preset === 'clean-light' && (
                  <>
                 
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Prefix (e.g., New Collection)</label>
                      <input
                        type="text"
                        value={prefix}
                        onChange={(e) => setPrefix(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        placeholder="New Collection"
                      />
                    </div>
                   

                  </>
                )}

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Main Message</label>
                  <input
                    type="text"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    placeholder="25% off sitewide — Limited time"
                  />
                </div>

                {preset === 'clean-light' && (
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">CTA Button Text</label>
                      <input
                        type="text"
                        value={ctaText}
                        onChange={(e) => setCtaText(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        placeholder="Shop Now"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Link URL</label>
                      <input
                        type="text"
                        value={link}
                        onChange={(e) => setLink(e.target.value)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        placeholder="/sale"
                      />
                    </div>
                  </div>
                )}

                {preset === 'premium-dark' && (
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Countdown Hours</label>
                      <input
                        type="number"
                        value={countdownHours}
                        onChange={(e) => setCountdownHours(parseInt(e.target.value) || 0)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        placeholder="12"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Countdown Minutes</label>
                      <input
                        type="number"
                        value={countdownMinutes}
                        onChange={(e) => setCountdownMinutes(parseInt(e.target.value) || 0)}
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        placeholder="34"
                      />
                    </div>
                  </div>
                )}

                <div className="flex items-center justify-between pt-2 border-t border-gray-200 mt-4">
                  <div>
                    <label className="text-sm font-medium text-gray-700">Dismissible</label>
                    <p className="text-xs text-gray-500">Let visitors close the bar</p>
                  </div>
                  <button
                    onClick={() => setDismissible(!dismissible)}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${
                      dismissible ? 'bg-blue-600' : 'bg-gray-200'
                    }`}
                  >
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${dismissible ? 'translate-x-6' : 'translate-x-1'}`} />
                  </button>
                </div>
              </div>

              {/* Dev Mode Toggle */}
              <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-6">
                <div className="flex items-start justify-between">
                  <div>
                    <h3 className="text-lg font-semibold text-yellow-900">Advanced Customization</h3>
                    <p className="text-sm text-yellow-800 mt-1">For pros: Override colors, height, etc. Use with care.</p>
                  </div>
                  <button
                    onClick={() => setDevMode(!devMode)}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 ${
                      devMode ? 'bg-yellow-600' : 'bg-gray-200'
                    }`}
                  >
                    <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${devMode ? 'translate-x-6' : 'translate-x-1'}`} />
                  </button>
                </div>

                {devMode && (
                  <div className="mt-6 space-y-4 border-t border-yellow-300 pt-6">
                    <h4 className="font-medium text-yellow-900 text-sm">Custom Overrides</h4>
                    
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-xs font-medium text-yellow-900">Background</label>
                        <input type="text" value={backgroundColor} onChange={(e) => setBackgroundColor(e.target.value)} className="w-full px-3 py-1.5 border border-yellow-300 rounded-md text-xs focus:outline-none focus:ring-2 focus:ring-yellow-500" placeholder="#ffffff or gradient" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-yellow-900">Text Color</label>
                        <input type="color" value={textColor} onChange={(e) => setTextColor(e.target.value)} className="h-8 w-full rounded border border-yellow-300" />
                      </div>
                    </div>

                     <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Prefix Text Color</label>
                      <input type="color" value={prefixTextColor} onChange={(e) => setPrefixTextColor(e.target.value)} className="h-8 w-full rounded border border-yellow-300" />
                    </div>
                    <div className="grid grid-cols-2 gap-4">
                    <div >
              <label className="block text-sm font-medium text-gray-700 mb-1">Prefix Icon</label>
              <select
                value={prefixIcon}
                onChange={(e) => setPrefixIcon(e.target.value)}
                className="w-full border border-gray-300 rounded-lg p-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none bg-gray-50"
              >
                <option value=""></option>
                <option>Sparkle</option>
                <option>Sparkles</option>
                <option>Percent</option>
                <option>CirclePercent</option>
                <option>Dessert</option>
                <option>CandyCane</option>
                
              </select>
            </div>
             <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Prefix Icon Color</label>
                      <input type="color" value={prefixIconColor} onChange={(e) => setPrefixIconColor(e.target.value)} className="h-8 w-full rounded border border-yellow-300" />
                    </div>
                    </div>
                     <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">CTA Text Color</label>
                      <input type="color" value={ctaColor} onChange={(e) => setCtaColor(e.target.value)} className="h-8 w-full rounded border border-yellow-300" />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-yellow-900">Height</label>
                      <input type="text" value={height} onChange={(e) => setHeight(e.target.value)} className="w-full px-3 py-1.5 border border-yellow-300 rounded-md text-xs focus:outline-none focus:ring-2 focus:ring-yellow-500" placeholder="56px" />
                    </div>
                  </div>
                )}
              </div>

              <button className="w-full bg-blue-600 text-white py-3 rounded-xl font-medium hover:bg-blue-700 transition-colors shadow-sm">
                Save & Publish
              </button>
            </>
          )}



          {preset === 'premium-dark' && (
            <div>
              <label className="block text-sm font-medium mb-1">Countdown End Date & Time</label>
              <input
                type="datetime-local"
                value={countdownDate.slice(0, 16)}
                onChange={(e) => setCountdownDate(e.target.value ? new Date(e.target.value).toISOString() : '')}
                className="w-full px-4 py-2 border rounded-md"
              />
            </div>
          )}

          {/* Dev Mode fields now use text input for full gradient support */}
          {devMode && (
            <div className="space-y-4 p-4 bg-yellow-50 rounded-lg">
              <input placeholder="Background (color or gradient)" value={backgroundColor} onChange={(e) => setBackgroundColor(e.target.value)} className="w-full px-3 py-2 border rounded" />
              <input placeholder="Text Color" value={textColor} onChange={(e) => setTextColor(e.target.value)} className="w-full px-3 py-2 border rounded" />
              <input placeholder="Height (e.g. 60px)" value={height} onChange={(e) => setHeight(e.target.value)} className="w-full px-3 py-2 border rounded" />
            </div>
          )}
        </div>

        {/* Live Preview */}
        <div className="sticky top-6">
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="bg-gray-100 p-4 border-b">
              <h3 className="font-semibold">Live Preview</h3>
            </div>
            <div className="bg-gradient-to-b from-sky-50 to-gray-100 min-h-screen">
              <FlashBar config={previewConfig} />
              <header className="bg-white shadow-sm p-6 text-center">
                <h1 className="text-3xl font-bold">Your Store</h1>
              </header>
              <main className="p-10">
                <div className="grid grid-cols-3 gap-6">
                  {[1,2,3,4,5,6].map(i => (
                    <div key={i} className="bg-white rounded-lg shadow p-6 text-center">
                      <div className="bg-gray-200 border-2 border-dashed rounded-xl w-32 h-32 mx-auto mb-4" />
                      <p>Product {i}</p>
                    </div>
                  ))}
                </div>
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlashBarAdmin;